/*
 * ep-konf-track.js — Nutzung der Konfiguratoren messen (Englputzeder, 22.10.2026, U0)
 *
 * Portiert aus my-Harry assets/mh-konf-track.js. Unterschiede:
 *  - Keine fest eingetragenen GA4-/Clarity-IDs. Ereignisse gehen per dataLayer.push an den
 *    vorhandenen Google Tag Manager (GTM-W49X777T); dort werden sie bei Bedarf an GA4 weitergeleitet.
 *  - Optional direkt an GA4: nur wenn window.EP_KONF_CFG.ga4 gesetzt ist UND gtag existiert
 *    (gtag('event', ..., { send_to: <ga4> })).
 *  - Microsoft Clarity nur, wenn window.EP_KONF_CFG.clarity gesetzt ist. Das Clarity-Skript wird erst
 *    nach Cookiebot-Einwilligung "Statistik" geladen; bis dahin sammelt nur die lokale Warteschlange.
 *  - Zusaetzlich Shopify Customer Events (Shopify.analytics.publish), wie bei my-Harry.
 *  - Pergola zusaetzlich erfasst (Root .mhpg).
 *
 * dataLayer-Ereignis: { event: 'konfigurator_aufgerufen' | '_genutzt' | '_warenkorb' | '_gespeichert' |
 *   '_pdf' | '_ki_bild', konfigurator: 'WPC-Dielen' | 'Terrassenplatten' | 'Sichtschutzzaun' |
 *   'Doppelstabmattenzaun' | 'Pergola', konf_key: 'wpc' | ..., quelle: 'seite' | 'popup' }
 * Keine persoenlichen Daten. Test: window.MH_TRACK_TEST = function (ev, params) {...}
 *
 * Wichtig: muss VOR ep-konf-suite.js laden (beide defer, Reihenfolge in layout/theme.liquid),
 * damit die Suite ihre Klaviyo-Aufrufe ueber diesen fetch schickt.
 */
(function () {
  'use strict';
  if (window.__mhKonfTrack) return;
  window.__mhKonfTrack = true;

  var CFG = window.EP_KONF_CFG || {};
  var GA4 = String(CFG.ga4 || '').trim();
  var CLARITY = String(CFG.clarity || '').trim();
  var LIVE = String(CFG.live || '').trim().replace(/\/+$/, '');

  var K = [
    { key: 'wpc',        name: 'WPC-Dielen',           sel: '#mhWpcRoot' },
    { key: 'terrassen',  name: 'Terrassenplatten',     sel: '#mhKonfRoot' },
    { key: 'zaun',       name: 'Sichtschutzzaun',      sel: '.mhzk-app' },
    { key: 'doppelstab', name: 'Doppelstabmattenzaun', sel: '.mhds-app' },
    { key: 'pergola',    name: 'Pergola',              sel: '.mhpg' }
  ];
  var BY_NAME = {};
  K.forEach(function (k) { BY_NAME[k.name] = k; });

  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function quelle(el) { return el && el.closest && el.closest('.mhtk-modal,[role="dialog"]') ? 'popup' : 'seite'; }

  /* ---- Microsoft Clarity (nur mit EP_KONF_CFG.clarity) ---- */
  var CL = {
    konfigurator_aufgerufen: 'view',
    konfigurator_genutzt: 'start',
    konfigurator_warenkorb: 'warenkorb',
    konfigurator_gespeichert: 'gespeichert',
    konfigurator_pdf: 'pdf',
    konfigurator_ki_bild: 'ki_bild'
  };
  function clarity() {
    if (!CLARITY) return;
    try { window.clarity.apply(window, arguments); } catch (e) {}
  }
  if (CLARITY) {
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    var clLoaded = false;
    var statsOk = function () {
      try {
        var cb = window.Cookiebot;
        if (cb && cb.consent) return cb.consent.statistics === true;
        var sp = window.Shopify && window.Shopify.customerPrivacy;
        if (sp && typeof sp.analyticsProcessingAllowed === 'function') return sp.analyticsProcessingAllowed() === true;
      } catch (e) {}
      return false;
    };
    var loadClarity = function () {
      if (clLoaded || !statsOk()) return;
      clLoaded = true;
      var t = document.createElement('script');
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(CLARITY);
      t.setAttribute('data-cookieconsent', 'statistics');
      (document.head || document.documentElement).appendChild(t);
    };
    window.addEventListener('CookiebotOnAccept', loadClarity);
    window.addEventListener('CookiebotOnConsentReady', loadClarity);
    document.addEventListener('visitorConsentCollected', loadClarity);
    loadClarity();
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role) clarity('set', 'theme_rolle', String(Shopify.theme.role)); } catch (e) {}
  }
  function toClarity(ev, k, src) {
    var s = CL[ev];
    if (!s || !CLARITY) return;
    if (ev === 'konfigurator_genutzt') {
      clarity('set', 'konfigurator', k.key);
      clarity('set', 'konf_quelle', src || 'seite');
      clarity('upgrade', 'konfigurator_' + k.key);
    }
    clarity('event', 'konf_' + k.key + '_' + s);
  }

  function send(ev, k, src) {
    var p = { konfigurator: k.name, konf_key: k.key, quelle: src || 'seite' };
    toClarity(ev, k, src);
    try { if (typeof window.MH_TRACK_TEST === 'function') { window.MH_TRACK_TEST(ev, p); return; } } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: ev, konfigurator: p.konfigurator, konf_key: p.konf_key, quelle: p.quelle });
    } catch (e) {}
    try { if (GA4 && typeof window.gtag === 'function') window.gtag('event', ev, { konfigurator: p.konfigurator, quelle: p.quelle, send_to: GA4 }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, p); } catch (e) {}
  }

  /* aufgerufen: sobald ein Konfigurator sichtbar wird */
  var seen = {}, used = {}, last = null, lastT = 0;
  function scan() {
    K.forEach(function (k) {
      var list = document.querySelectorAll(k.sel);
      for (var i = 0; i < list.length; i++) {
        if (!shown(list[i])) continue;
        var src = quelle(list[i]), id = k.key + ':' + src;
        if (!seen[id]) { seen[id] = 1; send('konfigurator_aufgerufen', k, src); }
        break;
      }
    });
  }

  /* Schritte (nur Clarity): hoechster erreichter Schritt je Konfigurator */
  var STEP = { wpc: '.stepper .step', terrassen: '.stepper .step', zaun: '.mhzk-step', doppelstab: '.mhds-step' };
  var maxStep = {}, lastStep = {};
  function steps(k, root) {
    var st = [];
    try { st = root.querySelectorAll(k.key === 'wpc' || k.key === 'terrassen' ? ':scope > .stepper .step' : STEP[k.key]); } catch (e) { st = []; }
    for (var n = root.parentElement, d = 0; !st.length && n && d < 4; n = n.parentElement, d++) {
      try { st = n.querySelectorAll(STEP[k.key]); } catch (e) { st = []; }
    }
    return st;
  }
  function scanSteps() {
    if (!CLARITY) return;
    K.forEach(function (k) {
      if (!STEP[k.key]) return;
      var list = document.querySelectorAll(k.sel);
      for (var i = 0; i < list.length; i++) {
        if (!shown(list[i])) continue;
        var id = k.key + ':' + quelle(list[i]);
        if (!used[id]) break;
        var st = steps(k, list[i]), act = -1;
        for (var j = 0; j < st.length; j++) {
          if (st[j].classList.contains('active') || st[j].classList.contains('is-active')) act = j;
        }
        if (act < 0) break;
        var from = maxStep[id] == null ? 0 : maxStep[id] + 1;
        for (var s = from; s <= act; s++) clarity('event', 'konf_' + k.key + '_schritt_' + (s + 1));
        if (act >= from) maxStep[id] = act;
        if (act === st.length - 1 && !lastStep[id]) { lastStep[id] = 1; clarity('event', 'konf_' + k.key + '_letzter_schritt'); }
        break;
      }
    });
  }

  /* genutzt: erste Interaktion im Konfigurator */
  function hit(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < K.length; i++) {
      var r = t.closest(K[i].sel);
      if (!r) continue;
      last = K[i]; lastT = Date.now();
      var src = quelle(r), id = K[i].key + ':' + src;
      if (!used[id]) { used[id] = 1; send('konfigurator_genutzt', K[i], src); }
      setTimeout(scanSteps, 400);
      return;
    }
  }
  document.addEventListener('pointerdown', hit, true);
  document.addEventListener('keydown', hit, true);

  function isLiveUrl(url) {
    if (!/\/live(\?|$)/.test(url)) return false;
    if (LIVE && url.indexOf(LIVE) === 0) return true;
    return /workers\.dev\/live(\?|$)/.test(url);
  }

  /* Warenkorb, Speichern, PDF, KI-Bild: an den Anfragen erkennen, die ohnehin rausgehen */
  var nf = window.fetch;
  if (nf) {
    window.fetch = function (input, init) {
      var ev = null, k = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var body = init && typeof init.body === 'string' ? init.body : '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          var m = /"_konfigurator"\s*:\s*"([^"]+)"/.exec(body);
          k = (m && BY_NAME[m[1]]) || (last && Date.now() - lastT < 60000 ? last : null);
          if (k) ev = 'konfigurator_warenkorb';
        } else if (/a\.klaviyo\.com\/client\/events/.test(url) && body) {
          var n = /"name"\s*:\s*"(Konfiguration gespeichert|Planung exportiert)"/.exec(body);
          var c = /"Konfigurator"\s*:\s*"([^"]+)"/.exec(body);
          if (n && c && BY_NAME[c[1]]) { k = BY_NAME[c[1]]; ev = n[1] === 'Planung exportiert' ? 'konfigurator_pdf' : 'konfigurator_gespeichert'; }
        } else if (isLiveUrl(url) && last) {
          k = last; ev = 'konfigurator_ki_bild';
        }
      } catch (e) { ev = null; }
      var p = nf.apply(this, arguments);
      if (ev && k) {
        var src = 'seite';
        try { var r = document.querySelector(k.sel); src = quelle(r); } catch (e) {}
        p.then(function (res) { if (res && res.ok) send(ev, k, src); }).catch(function () {});
      }
      return p;
    };
  }

  /* Speichern/PDF ohne Klaviyo: die Suite meldet das ueber MHKonf-Ereignisse nicht - deshalb zusaetzlich
     an den Klicks auf die Absende-Knoepfe der Suite-Dialoge erkennen (nur wenn Klaviyo aus ist). */
  var KL_ON = !!(CFG.klaviyo && CFG.klaviyo.company);
  if (!KL_ON) {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('mhks-box')) return;
      var lbl = f.getAttribute('aria-label') || '';
      var ev = lbl === 'Planung speichern' ? 'konfigurator_gespeichert' : lbl === 'Planung exportieren' ? 'konfigurator_pdf' : null;
      if (!ev || !last) return;
      var k0 = last, done = false;
      /* Erfolg = Dialog hat sich geschlossen (bei Fehlern bleibt er offen) */
      var chk = function () { if (!done && !f.isConnected) { done = true; send(ev, k0, 'seite'); } };
      setTimeout(chk, 500); setTimeout(chk, 3600);
    }, true);
  }

  function init() { scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(function () { scan(); scanSteps(); }, 1500);
  document.addEventListener('visibilitychange', scan);
})();